export default __webpack_public_path__ + "static/victoria-card-6e5a6f14856f56d7724c073ac1d03674.jpg";